import "./__styles__/Icon.scss";
import React from "react";

type SizePreset = "small" | "medium" | "large";

type Props = {
  size?: SizePreset | number;
};

const sizePresetMap: Record<SizePreset, number> = {
  small: 16,
  medium: 24,
  large: 64,
};

export function Loading({ size = "large" }: Props) {
  const evaluatedSize = typeof size === "string" ? sizePresetMap[size] : size;
  const pixelSize = `${evaluatedSize}px`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={pixelSize}
      height={pixelSize}
      viewBox="0 0 100 100"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#c4c6ca"
        strokeWidth="8"
        r="35"
      />
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#212121"
        strokeWidth="8"
        r="35"
        strokeDasharray="50 169"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1.5s"
          from="0 50 50"
          to="360 50 50"
        />
      </circle>
    </svg>
  );
}

export default Loading;
